import { getCookie, setCookie } from './cookie';

/**
 * @deprecated Use useCookieStorage instead
 */
export const getOrStoreCookie = (
  cookie_name: string,
  default_value: string,
  days: number = 365
): string => {
  const existing = getCookie(cookie_name);

  setCookie(cookie_name, existing ?? default_value, days);

  return existing ?? default_value;
};
